import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HERO_PRODUCE_IMAGE, HERO_SEEDS_IMAGE, HERO_TOOLS_IMAGE } from "../../constants/images";

export default function HeroSection() {
  const navigate = useNavigate();
const slides = [
  {
    image: HERO_PRODUCE_IMAGE,
    title: "FRESH FROM THE FIELD",
    subtitle:
      "Fruit and vegetables picked at their peak and delivered fast. Grown by farmers we know, sold at prices that make sense.",
    cta: "Shop Fresh Produce",
    cat: "fresh-produce",
  },
  {
    image: HERO_SEEDS_IMAGE,
    title: "GROW SOMETHING NEW",
    subtitle:
      "Heirloom seeds and ready-to-plant seedlings for the garden or the field. Everything you need to start the next season right.",
    cta: "Shop Seeds & Plants",
    cat: "seeds-plants",
  },
  {
    image: HERO_TOOLS_IMAGE,
    title: "BUILT FOR THE WORK",
    subtitle:
      "Reliable tools and equipment for growers of every size — from a backyard bed to a working farm.",
    cta: "Shop Tools & Equipment",
    cat: "garden-tools",
  },
];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  // Automatic slider
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 8000);

    return () => clearInterval(timer);
  }, [slides.length]);

  // Mouse Parallax
  const [mouse, setMouse] = useState({
    x: 0,
    y: 0,
  });

  useEffect(() => {
    const move = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 30;
      const y = (e.clientY / window.innerHeight - 0.5) * 30;

      setMouse({ x, y });
    };

    window.addEventListener("mousemove", move);

    return () => window.removeEventListener("mousemove", move);
  }, []);

    return (
    <section
      style={{
        position: "relative",
        width: "100%",
        height: "100vh",
        minHeight: 760,
        overflow: "hidden",
        background: "#000",
      }}
    >
      {/* ---------------- Background Slides ---------------- */}

      {slides.map((slide, index) => (
        <div
          key={index}
          style={{
            position: "absolute",
            inset: 0,

            opacity: currentSlide === index ? 1 : 0,

            transition:
              "opacity 1.5s cubic-bezier(.4,0,.2,1)",

            overflow: "hidden",
          }}
        >
          <img
            src={slide.image}
            alt={slide.title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",

              transform:
                currentSlide === index
                  ? `scale(1.12) translate(${mouse.x}px, ${mouse.y}px)`
                  : "scale(1)",

              transition:
                "transform 8s ease, opacity 1.5s ease",

              willChange: "transform",
            }}
          />

          {/* Luxury Overlay */}

          <div
            style={{
              position: "absolute",
              inset: 0,

              background:
                `
linear-gradient(
180deg,
rgba(0,0,0,.18) 0%,
rgba(0,0,0,.34) 45%,
rgba(0,0,0,.55) 100%)
`,
            }}
          />

          {/* Premium vignette */}

          <div
            style={{
              position: "absolute",
              inset: 0,

              background:
                "radial-gradient(circle at center, transparent 35%, rgba(0,0,0,.28) 100%)",
            }}
          />
        </div>
      ))}

      {/* ---------------- Content Container ---------------- */}

      <div
        style={{
          position: "relative",
          zIndex: 10,

          maxWidth: 1450,

          height: "100%",

          margin: "0 auto",

          padding: "0 70px",

          display: "flex",

          alignItems: "center",
        }}
      >
     {/* =========================
            HERO CONTENT
        ========================== */}

        <div
          style={{
            maxWidth: 760,
            color: "#fff",
            userSelect: "none",
          }}
        >
          {/* Small Tag */}

          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 12,
              marginBottom: 28,

              opacity: loaded ? 1 : 0,
              transform: loaded
                ? "translateY(0)"
                : "translateY(25px)",

              transition: ".9s ease",
            }}
          >
            <div
              style={{
                width: 46,
                height: 1,
                background: "rgba(255,255,255,.8)",
              }}
            />

            <span
              style={{
                letterSpacing: ".45em",
                fontSize: 12,
                textTransform: "uppercase",
                fontWeight: 600,
              }}
            >
              FRESH THIS WEEK
            </span>
          </div>

          {/* Main Heading */}

          <h1
            key={slides[currentSlide].title}
            style={{
              margin: 0,

              fontFamily: "'Cormorant Garamond', serif",

              fontWeight: 600,

              fontSize: "clamp(48px, 6vw, 88px)",

              lineHeight: .92,

              letterSpacing: "-.04em",

              textTransform: "uppercase",

              opacity: loaded ? 1 : 0,

              transform: loaded
                ? "translateY(0)"
                : "translateY(45px)",

              transition: ".9s ease",
            }}
          >
            {slides[currentSlide].title}
          </h1>

          {/* Subtitle */}

          <p
            key={slides[currentSlide].subtitle}
            style={{
              marginTop: 34,

              maxWidth: 640,

              fontSize: 20,

              lineHeight: 1.9,

              color: "rgba(255,255,255,.88)",

              fontWeight: 300,

              letterSpacing: ".03em",

              opacity: loaded ? 1 : 0,

              transform: loaded
                ? "translateY(0)"
                : "translateY(30px)",

              transition: "1.1s ease",
            }}
          >
            {slides[currentSlide].subtitle}
          </p>

          {/* Buttons */}

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 18,

              marginTop: 55,

              opacity: loaded ? 1 : 0,

              transform: loaded
                ? "translateY(0)"
                : "translateY(35px)",

              transition: "1.3s ease",
            }}
          >
            {/* Primary */}

            <button
              onClick={() => navigate(`/shop?cat=${slides[currentSlide].cat}`)}
              style={{
                height: 62,

                padding: "0 46px",

                border: "none",

                cursor: "pointer",

                borderRadius: 4,

                background: "#fff",

                color: "#111",

                fontSize: 13,

                fontWeight: 700,

                letterSpacing: ".28em",

                textTransform: "uppercase",

                transition: ".35s",

                boxShadow:
                  "0 8px 24px rgba(0,0,0,0.04)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform =
                  "translateY(-3px)";

                e.currentTarget.style.background =
                  "#f5f5f5";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform =
                  "translateY(0px)";

                e.currentTarget.style.background =
                  "#fff";
              }}
            >
              {slides[currentSlide].cta}
            </button>

            {/* Secondary */}

            <button
              onClick={() => navigate("/advice")}
              style={{
                height: 62,

                padding: "0 46px",

                background: "transparent",

                color: "#fff",

                border:
                  "1px solid rgba(255,255,255,.65)",

                cursor: "pointer",

                borderRadius: 4,

                fontSize: 13,

                fontWeight: 700,

                letterSpacing: ".28em",

                textTransform: "uppercase",

                transition: ".35s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background =
                  "#fff";

                e.currentTarget.style.color =
                  "#111";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background =
                  "transparent";

                e.currentTarget.style.color =
                  "#fff";
              }}
            >
              Growing Tips & Guides
            </button>
          </div>

          {/* Slide Indicators */}

          <div
            style={{
              display: "flex",
              alignItems: "center",

              gap: 12,

              marginTop: 80,
            }}
          >
            {slides.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentSlide(i)}
                style={{
                  width:
                    i === currentSlide
                      ? 60
                      : 24,

                  height: 3,

                  border: "none",

                  cursor: "pointer",

                  background:
                    i === currentSlide
                      ? "#ffffff"
                      : "rgba(255,255,255,.35)",

                  transition:
                    ".45s cubic-bezier(.4,0,.2,1)",
                }}
              />
            ))}
          </div>
        </div>

        {/* Scroll Indicator */}

        <div
          style={{
            position: "absolute",

            left: "50%",

            bottom: 40,

            transform: "translateX(-50%)",

            color: "#fff",

            textAlign: "center",

            opacity: .85,
          }}
        >
          <div
            style={{
              fontSize: 11,

              letterSpacing: ".45em",

              textTransform: "uppercase",

              marginBottom: 12,
            }}
          >
            Scroll
          </div>

          <div
            style={{
              width: 1,

              height: 55,

              background:
                "rgba(255,255,255,.6)",

              margin: "0 auto",

              animation:
                "heroScroll 1.8s infinite",
            }}
          />
        </div>
      </div>

      {/* =========================
          Hero Animations
      ========================== */}

      <style>
        {`
        
        @keyframes heroScroll {
          0%{
            transform:translateY(0);
            opacity:1;
          }

          50%{
            transform:translateY(12px);
            opacity:.35;
          }

          100%{
            transform:translateY(0);
            opacity:1;
          }
        }

        @keyframes heroFadeUp{
          from{
            opacity:0;
            transform:translateY(40px);
          }

          to{
            opacity:1;
            transform:translateY(0);
          }
        }

        @keyframes heroZoom{

          from{
            transform:scale(1);
          }

          to{
            transform:scale(1.12);
          }

        }

        @media (max-width:1200px){

          section .hero-content{

            max-width:650px;

          }

        }

        @media (max-width:992px){

          h1{

            font-size:72px !important;

          }

        }

        @media (max-width:768px){

          section{

            min-height:680px !important;

          }

          h1{

            font-size:54px !important;

            line-height:.95 !important;

          }

          p{

            font-size:18px !important;

            line-height:1.7 !important;

          }

        }

        @media (max-width:576px){

          h1{

            font-size:42px !important;

          }

          p{

            font-size:16px !important;

          }

        }

      `}
      </style>

    </section>
  );
}
